import { baseUrl } from '../http';
import axios from 'axios';
import moment from 'moment';
import { dateLocale, serverDateLocale } from "../../utils"

const participantUrl = (tripId, participantId) => `${baseUrl}/trip/${tripId}/participant/${participantId}/payment`;
const paymentUrl = (tripId, participantId, payId) => `${participantUrl(tripId, participantId)}/${payId}`;

export const paymentApi = {
    async allPayments(tripId, participantId) {
        const res = await axios.get(`${participantUrl(tripId, participantId)}/all`);
        if (res.data.success)
            return res.data.payments.map(p => { return { ...p, date: dateToLocalString(p.date) } });
        return Promise.reject("Error getting all payments");
    },

    async addPayment(tripId, participantId, paymentDetails) {
        let details = {
            ...paymentDetails,
            amount:formatAmount("" + paymentDetails.amount),
            date: dateToServerLocale(paymentDetails.date)
        }
        const res = await axios.put(`${participantUrl(tripId, participantId)}`, details);
        if (res.data.success)
            return res.data.payment;
        return Promise.reject("Payment cannot be created");
    },

    async getPayment(tripId, participantId, paymentId) {
        const res = await axios.get(paymentUrl(tripId, participantId, paymentId));
        if (res.data.success)
            return res.data.payment;
        return Promise.reject("Cannot get this payment");
    },

    changePaymentType(tripId, participantId, paymentId, newType) {
        return modifyPayment(tripId, participantId, paymentId, "paymentType", newType);
    },

    changePaymentAmount(tripId, participantId, paymentId, newAmount) {
        return modifyPayment(tripId, participantId, paymentId, "amount",formatAmount("" + newAmount) );
    },

    generateInvoice(tripId, participantId, paymentId, invoiceNumber) {
        return generateInvoiceRequest(tripId, participantId, paymentId, invoiceNumber, false);
    },

    generateCredit(tripId, participantId, paymentId, invoiceNumber) {
        return generateInvoiceRequest(tripId, participantId, paymentId, invoiceNumber, true);
    },
}

const modifyPayment = async (tripId, participantId, paymentId, attribute, value) => {
    const res = await axios.post(paymentUrl(tripId, participantId, paymentId), {
        attribute,
        value
    });
    if (res.data.success)
        return res.data.payment;
    return Promise.reject("Cannot modify payment");
}

const generateInvoiceRequest = async (tripId, participantId, paymentId, invoiceNumber, isCredit) => {
    const res = await axios.get(paymentUrl(tripId, participantId, paymentId)+"/invoice", {
        params: {
            invoiceNumber,
            isCredit
        }
    });
    if (res.data.success) {
        return res.data.document;
    }
    return Promise.reject("Cannot generate invoice.");
}

const formatAmount = (amount)=> amount.replace(',','.');

const dateToServerLocale = date => moment(date, dateLocale).format(serverDateLocale);

const dateToLocalString = date => moment(date, serverDateLocale).format(dateLocale);